// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"489d3d5d","232":"20d9301c","787":"4cc5d4af","789":"eeb054fd","981":"5529082d"}[chunkId] + ".chunk.js";
};